import React, { Component } from 'react';
import { GenericEditPanel, GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class CanalVenta extends Component {
    constructor(props) {
        super(props);

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.changeInput = this.changeInput.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    changeInput(event) {
        this.props.changeInput(1, this.props.codigoNovedad, event.target.value)
    }
    /**
     * 
     */
    render() {
        let props = this.props;
        let seEstaEditando = props.dataCompleto.seEstaEditando;
        let me = this;
        let errors;
        const { getFieldProps, getFieldError } = this.props.form;
        let errorContainer;

        errorContainer = <label className="error">
            {(errors = getFieldError('canalVenta')) ? errors.join(',') : null}</label>

        let error = (getFieldError('canalVenta')) ? true : false

        //////////Novedad en Canal de Venta////////////
        let descripcion = props.data.CanalVentaVisaCodigo;
        let novedadCanalVenta = undefined;
        if (props.dataCompleto.novedadesCuentaDatos != undefined) {
            novedadCanalVenta = props.dataCompleto.novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == this.props.codigoNovedad);

            if (novedadCanalVenta != undefined) {

                novedadCanalVenta.ValorAnteriorFormateado = novedadCanalVenta.ValorAnterior != "" ? novedadCanalVenta.ValorAnterior : "Sin especificar";

                const esNovedadEditadaDescripcion = props.dataCompleto.esNovedadEditada.find(x => x.campoCodigo == this.props.codigoNovedad).editado;

                if (esNovedadEditadaDescripcion == false) {
                    descripcion = novedadCanalVenta.ValorNovedad;
                }
            }
        }
        ////////////////////////////////////////////////////
        let componente = <div>
            <GenericInputValidate
                getFieldProps={getFieldProps('canalVenta', {
                    onChange(e) {
                        me.changeInput(e);
                    },
                    rules: [{
                        required: true,
                        pattern: /^[a-zA-Z0-9\s]*$/,
                        message: 'Debe ingresar valor válido.'
                    }]
                })}
                id="canalVenta"
                name="canalVenta"
                value={descripcion}
                className="form-control default-input"
                autoComplete="off"
            />
            {errorContainer}
        </div>

        return (
            <GenericEditPanel
                componente={componente}
                cuenta={props.data}
                error={(error || (descripcion == undefined || descripcion == ""))}
                novedad={novedadCanalVenta}
                seEstaEditando={seEstaEditando}
                permisoUsuario={props.dataCompleto.funcionesDelUsuario}
                textPanel={descripcion || "Sin especificar"}
                title="Canal de Venta"
                value={descripcion}

                aceptChanges={(value) => this.props.guardarNovedad(value)}
                confirmarNovedad={() => this.actualizarNovedadEstado(novedadCanalVenta, 2, props.data.CuentaTarjetaId)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(novedadCanalVenta, 3, props.data.CuentaTarjetaId)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar} />
        );
    }
}

export default CanalVenta;